import LangEnum from '../../../../../lang/LangEnum';
import { CatalogCardVariantKey } from './catalogCardColumns.types';
import { CatalogCardSizeVariant } from './catalogCardSize.types';

const SMALL: CatalogCardSizeVariant = {
  key: CatalogCardVariantKey.SMALL,
  label: LangEnum.CATALOG_CARD_SIZE_SMALL,
  maxWidth: 230,
};

const MEDIUM: CatalogCardSizeVariant = {
  key: CatalogCardVariantKey.MEDIUM,
  label: LangEnum.CATALOG_CARD_SIZE_MEDIUM,
  maxWidth: 400,
};

const LARGE: CatalogCardSizeVariant = {
  key: CatalogCardVariantKey.LARGE,
  label: LangEnum.CATALOG_CARD_SIZE_LARGE,
  maxWidth: 650,
};

export const CATALOG_CARD_SIZE_VARIANTS: CatalogCardSizeVariant[] = [SMALL, MEDIUM, LARGE];

export const DEFAULT_CATALOG_CARD_SIZE_KEY = MEDIUM.key;

export const findCatalogCardSizeVariant = (key: string): CatalogCardSizeVariant =>
  CATALOG_CARD_SIZE_VARIANTS.find((variant) => variant.key === key) ?? MEDIUM;
